module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "C593"
  }, [_c('span', {
    staticClass: "size_145"
  }, [_c('span', {
    staticClass: "color_0B0E11"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Balance")]), _vm._v(" and Symmetry")])])])]), _vm._v(" "), _c('p', {
    staticClass: "C580"
  }, [_vm._v("Balance is that fine line between unity and variety. Equilibrium between your design elements creates balance. In design terms, balance can be achieved in a formal way through symmetry or more informally through asymmetry. Symmetrical balance is achieved when both sides are mirror images of each other. Asymmetrical balance is when both sides are balanced through the use of different elements—for example, several small elements are balanced by one larger element. This type of balance is more difficult to achieve, but it can break monotony and create points of visual interest.")])]), _vm._v(" "), _c('p', {
    staticClass: "C580"
  }, [_vm._v("The symmetry in "), _c('em', [_vm._v("Sublime Triangle")]), _vm._v(" creates an ordered, balanced design.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "C572"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "img/16_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "C694"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_c('em', [_vm._v("Sublime Triangle")])]), _vm._v(" "), _c('span', {
    staticClass: "size_70"
  }, [_vm._v("("), _c('span', {
    attrs: {
      "href": "#/xhtml/26_Sublime#page_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 64")]), _vm._v(")")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-549b4690","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/13___Balanc.vue
// module id = 90
// module chunks = 0